import React, {PropsWithChildren, useContext} from 'react'

import {useFloating, useInteractions} from '@floating-ui/react'

interface DialogContext {
  refs: ReturnType<typeof useFloating>['refs']
  getFloatingProps: ReturnType<typeof useInteractions>['getFloatingProps']
  context: ReturnType<typeof useFloating>['context']
  close: () => void
}

const Context = React.createContext<DialogContext>(null as any)

interface DialogContextProviderProps {
  refs: ReturnType<typeof useFloating>['refs']
  getFloatingProps: ReturnType<typeof useInteractions>['getFloatingProps']
  context: ReturnType<typeof useFloating>['context']
  close: () => void
}

export const DialogContextProvider: React.FC<PropsWithChildren<DialogContextProviderProps>> = ({
  refs,
  getFloatingProps,
  context,
  close,
  children,
}) => {
  return (
    <Context.Provider
      value={{
        refs,
        getFloatingProps,
        context,
        close,
      }}
    >
      {children}
    </Context.Provider>
  )
}

export const useDialogContext = () => useContext(Context)
